import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enVuetify from '@/locales/vuetify/en'
import esVuetify from '@/locales/vuetify/es'

Vue.use(VueI18n)

function getVuetifyLocalizationFile (lang) {
  return lang === 'es' ? esVuetify : enVuetify
}

function loadLocaleMessages () {
  const locales = require.context('../locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
      messages[locale].$vuetify = getVuetifyLocalizationFile(locale)
    }
  })
  return messages
}

// obtenemos el idioma de sesion
var idioma = localStorage.getItem('i18n')

if (idioma === null) {
  idioma = 'es'
  localStorage.setItem('i18n', 'es')
}
console.log(idioma)
export default new VueI18n({
  locale: idioma,
  fallbackLocale: idioma,
  messages: loadLocaleMessages()
})
